"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"
import { useAuth } from "../context/AuthContext"
import { FiPlus, FiEdit2, FiTrash2 } from "react-icons/fi"

const Tasks = () => {
    const { user, isAdmin } = useAuth()
    const [tasks, setTasks] = useState([])
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [selectedTask, setSelectedTask] = useState(null)
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        status: "pending",
        due_date: "",
        assigned_to: "",
    })
    const [error, setError] = useState("")

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        try {
            const [tasksRes, usersRes] = await Promise.all([
                api.get("/tasks"),
                isAdmin ? api.get("/users") : Promise.resolve({ data: [] }),
            ])
            setTasks(tasksRes.data.data || tasksRes.data)
            setUsers(usersRes.data.data || usersRes.data)
        } catch (error) {
            console.error("Veri yüklenemedi:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError("")

        try {
            if (selectedTask) {
                await api.put(`/tasks/${selectedTask.id}`, formData)
            } else {
                await api.post("/tasks", formData)
            }
            setShowModal(false)
            resetForm()
            loadData()
        } catch (error) {
            setError(error.response?.data?.message || "İşlem başarısız")
        }
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Bu görevi silmek istediğinizden emin misiniz?")) return

        try {
            await api.delete(`/tasks/${id}`)
            loadData()
        } catch (error) {
            alert("Silme işlemi başarısız")
        }
    }

    const handleEdit = (task) => {
        setSelectedTask(task)
        setFormData({
            title: task.title,
            description: task.description || "",
            status: task.status,
            due_date: task.due_date || "",
            assigned_to: task.assigned_to || "",
        })
        setShowModal(true)
    }

    const resetForm = () => {
        setFormData({
            title: "",
            description: "",
            status: "pending",
            due_date: "",
            assigned_to: "",
        })
        setSelectedTask(null)
        setError("")
    }

    if (loading) {
        return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
    }

    return React.createElement(
        "div",
        { className: "tasks-page" },
        React.createElement(
            "div",
            { className: "page-header" },
            React.createElement("h1", null, "Görev Yönetimi"),
            isAdmin &&
            React.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: () => {
                        resetForm()
                        setShowModal(true)
                    },
                },
                React.createElement(FiPlus),
                "Yeni Görev",
            ),
        ),
        React.createElement(
            "div",
            { className: "card" },
            React.createElement(
                "div",
                { className: "table-container" },
                React.createElement(
                    "table",
                    { className: "desktop-table" },
                    React.createElement(
                        "thead",
                        null,
                        React.createElement(
                            "tr",
                            null,
                            React.createElement("th", null, "Başlık"),
                            React.createElement("th", null, "Durum"),
                            React.createElement("th", null, "Atanan"),
                            React.createElement("th", null, "Bitiş Tarihi"),
                            React.createElement("th", null, "İşlemler"),
                        ),
                    ),
                    React.createElement(
                        "tbody",
                        null,
                        tasks.map((task) =>
                            React.createElement(
                                "tr",
                                { key: task.id },
                                React.createElement("td", null, task.title),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "span",
                                        {
                                            className: `badge ${
                                                task.status === "completed"
                                                    ? "badge-success"
                                                    : task.status === "in_progress"
                                                        ? "badge-info"
                                                        : "badge-warning"
                                            }`,
                                        },
                                        task.status === "completed"
                                            ? "Tamamlandı"
                                            : task.status === "in_progress"
                                                ? "Devam Ediyor"
                                                : "Beklemede",
                                    ),
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    task.assigned_user ? `${task.assigned_user.first_name} ${task.assigned_user.last_name}` : "-",
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    task.due_date ? new Date(task.due_date).toLocaleDateString("tr-TR") : "-",
                                ),
                                React.createElement(
                                    "td",
                                    null,
                                    React.createElement(
                                        "div",
                                        { className: "action-buttons" },
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon", onClick: () => handleEdit(task) },
                                            React.createElement(FiEdit2),
                                        ),
                                        isAdmin &&
                                        React.createElement(
                                            "button",
                                            { className: "btn-icon danger", onClick: () => handleDelete(task.id) },
                                            React.createElement(FiTrash2),
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            React.createElement(
                "div",
                { className: "mobile-cards" },
                tasks.map((task) =>
                    React.createElement(
                        "div",
                        { key: task.id, className: "mobile-card" },
                        React.createElement(
                            "div",
                            { className: "mobile-card-header" },
                            React.createElement("h3", null, task.title),
                            React.createElement(
                                "div",
                                { className: "action-buttons" },
                                React.createElement(
                                    "button",
                                    { className: "btn-icon", onClick: () => handleEdit(task) },
                                    React.createElement(FiEdit2),
                                ),
                                isAdmin &&
                                React.createElement(
                                    "button",
                                    { className: "btn-icon danger", onClick: () => handleDelete(task.id) },
                                    React.createElement(FiTrash2),
                                ),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "mobile-card-body" },
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Durum:"),
                                React.createElement(
                                    "span",
                                    {
                                        className: `badge ${
                                            task.status === "completed"
                                                ? "badge-success"
                                                : task.status === "in_progress"
                                                    ? "badge-info"
                                                    : "badge-warning"
                                        }`,
                                    },
                                    task.status === "completed"
                                        ? "Tamamlandı"
                                        : task.status === "in_progress"
                                            ? "Devam Ediyor"
                                            : "Beklemede",
                                ),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Atanan:"),
                                React.createElement(
                                    "span",
                                    { className: "value" },
                                    task.assigned_user ? `${task.assigned_user.first_name} ${task.assigned_user.last_name}` : "-",
                                ),
                            ),
                            React.createElement(
                                "div",
                                { className: "mobile-card-row" },
                                React.createElement("span", { className: "label" }, "Bitiş Tarihi:"),
                                React.createElement(
                                    "span",
                                    { className: "value" },
                                    task.due_date ? new Date(task.due_date).toLocaleDateString("tr-TR") : "-",
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        ),
        showModal &&
        React.createElement(
            "div",
            { className: "modal-overlay", onClick: () => setShowModal(false) },
            React.createElement(
                "div",
                { className: "modal", onClick: (e) => e.stopPropagation() },
                React.createElement("h2", null, selectedTask ? "Görev Düzenle" : "Yeni Görev"),
                error && React.createElement("div", { className: "error-message" }, error),
                React.createElement(
                    "form",
                    { onSubmit: handleSubmit },
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Başlık *"),
                        React.createElement("input", {
                            type: "text",
                            value: formData.title,
                            onChange: (e) => setFormData({ ...formData, title: e.target.value }),
                            required: true,
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Açıklama"),
                        React.createElement("textarea", {
                            value: formData.description,
                            onChange: (e) => setFormData({ ...formData, description: e.target.value }),
                        }),
                    ),
                    React.createElement(
                        "div",
                        { className: "form-row" },
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Durum"),
                            React.createElement(
                                "select",
                                {
                                    value: formData.status,
                                    onChange: (e) => setFormData({ ...formData, status: e.target.value }),
                                },
                                React.createElement("option", { value: "pending" }, "Beklemede"),
                                React.createElement("option", { value: "in_progress" }, "Devam Ediyor"),
                                React.createElement("option", { value: "completed" }, "Tamamlandı"),
                            ),
                        ),
                        React.createElement(
                            "div",
                            { className: "input-group" },
                            React.createElement("label", null, "Bitiş Tarihi"),
                            React.createElement("input", {
                                type: "date",
                                value: formData.due_date,
                                onChange: (e) => setFormData({ ...formData, due_date: e.target.value }),
                            }),
                        ),
                    ),
                    isAdmin &&
                    React.createElement(
                        "div",
                        { className: "input-group" },
                        React.createElement("label", null, "Atanan Personel *"),
                        React.createElement(
                            "select",
                            {
                                value: formData.assigned_to,
                                onChange: (e) => setFormData({ ...formData, assigned_to: e.target.value }),
                                required: true,
                            },
                            React.createElement("option", { value: "" }, "Seçiniz"),
                            users.map((user) =>
                                React.createElement(
                                    "option",
                                    { key: user.id, value: user.id },
                                    `${user.first_name} ${user.last_name}`,
                                ),
                            ),
                        ),
                    ),
                    React.createElement(
                        "div",
                        { className: "modal-actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-secondary", onClick: () => setShowModal(false) },
                            "İptal",
                        ),
                        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
                    ),
                ),
            ),
        ),
    )
}

export default Tasks
